import { setupWorker } from 'msw';
import exampleHandlers from './handlers/exampleHandlers';

export function registerServiceWorker() {
  const worker = setupWorker(...exampleHandlers);
  worker.start();
  return worker;
}
